import React, { FC } from 'react'
import { FormModal } from 'transfix-ui/components/Modals'
import { ErrorResponse, useDeleteCMLaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'

interface IDeleteLaneAlertModalProps {
  carrierId: number
  deleteId: number
  onCloseModal: () => void
  onSuccess: () => void
}

export const DeleteLaneAlertModal: FC<IDeleteLaneAlertModalProps> = ({
  carrierId,
  deleteId,
  onCloseModal,
  onSuccess,
}) => {
  const { error, loading, mutate: deleteLaneAlert } = useDeleteCMLaneAlert({ carrierId })
  const { data: messages } = error || {}
  const errorMessage = messages ? (messages as ErrorResponse) : { errors: '' }

  const confirmDelete = () => {
    deleteLaneAlert(`${deleteId}`).then(() => {
      onSuccess()
      onCloseModal()
    })
  }

  return (
    <FormModal
      title='Are you sure?'
      size={4}
      open
      actions={[
        { label: 'Cancel', type: 'dismiss', disabled: loading },
        {
          label: 'Delete',
          type: 'confirm',
          disabled: loading,
          action: confirmDelete,
        },
      ]}
      onClose={onCloseModal}
      dataTest='delete-load'
      error={errorMessage.errors}>
      This carrier will no longer receive lane alerts on this lane.
    </FormModal>
  )
}
